_ = require 'underscore'

isValidDataImage = (url) ->
  _.isString(url) &&
  /^data:image\/(?:png|jpg|jpeg|gif|svg\+xml);base64,[A-Za-z0-9+\/=_-]+$/.test(url)

isValidHttp = (url) ->
  _.isString(url) &&
  /^https?:\/\//.test(url)

isValidUrlForImage = (url) ->
  isValidHttp(url) || isValidDataImage(url)

# when putting image URLs in CSS, we don't want you to be able
# to escape the CSS property with a ' or " and try to set other
# css properties behind our backs
isValidUrlForCSSImage = (url) ->
  isValidUrlForImage(url) && !/['"]/.test(url)

isValidUrlForIframe = (url) ->
  isValidHttp(url)

isValidHeight = (height, maxHeight = Infinity, minHeight = 1) ->
  if !height? || !_.isNumber(height)
    return false
  return height >= minHeight && height <= maxHeight

isValidHexColor = (colorString) ->
  if _.isString(colorString) && /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(colorString)
    return true

  return false

# Expected Shape of pluginBadge:
#   icon?: url
#   text?: string | number
#   title?: string (cardDetail)
#   color?: string
#   dynamic?: function
#   refresh?: number
#   callback?: function (cardDetail)
#   url?: string (cardDetail)
#   target?: string (cardDetail)
isValidBadge = (pluginBadge) ->
  if !pluginBadge? || !_.isObject(pluginBadge)
    return false
  if pluginBadge.text? && (!_.isString(pluginBadge.text) && !_.isFinite(pluginBadge.text))
    return false
  if pluginBadge.title? && !_.isString(pluginBadge.title)
    return false
  if pluginBadge.icon? && !isValidUrlForCSSImage(pluginBadge.icon)
    return false
  if pluginBadge.dynamic? && !_.isFunction(pluginBadge.dynamic)
    return false
  if pluginBadge.refresh? && !_.isFinite(pluginBadge.refresh)
    return false

  return true

isValidCardBackSection = (section) ->
  errorMessages = []
  if !_.isObject(section)
    return false
  ok = true
  if !_.isString(section.title)
    ok = false
    errorMessages.push("Missing valid title.")
  if !_.isString(section.icon)
    ok = false
    errorMessages.push("Missing valid icon.")
  if !_.isObject(section.content)
    ok = false
    errorMessages.push("Missing valid content property.")
  if (section.content?.type != 'iframe')
    ok = false
    errorMessages.push("Content type must be 'iframe'.")
  if !isValidUrlForIframe(section.content?.url)
    ok = false
    errorMessages.push("Missing valid content url.")
  if !ok
    finalErrors = errorMessages.join('\n')
    console?.error("Failed to load card back section in plugin #{section.idPlugin}:
      \n\n#{finalErrors}
      \n\nSee https://developers.trello.com/reference/#card-back-section")
  return ok

isValidAttachmentSections = (section, attachmentList) ->
  errorMessages = []
  if !_.isObject(section)
    return false
  ok = true
  if !_.isString(section.icon)
    console?.warn("Warning in plugin #{section.idPlugin}:
      Attachment sections icon is missing.")
  if !_.isObject(section.content)
    ok = false
    errorMessages.push("Missing valid content property.")
  if !isValidUrlForIframe(section.content?.url)
    ok = false
    errorMessages.push("Missing valid content url.")
  if !_.isArray(section.claimed)
    ok = false
    errorMessages.push("Missing valid claimed property.")
  if !_.every(section.claimed, (entry) => entry?.id? && attachmentList.get(entry.id)?)
    ok = false
    errorMessages.push("Missing id's in claimed entries.")
  if !ok
    finalErrors = errorMessages.join('\n')
    console?.error("Failed to load attachment sections in plugin #{section.idPlugin}:
      \n\n#{finalErrors}
      \n\nSee https://developers.trello.com/reference/#attachment-sections")
  if (section.claimed?.length == 0)
    ok = false
  return ok

isRenderableBadge = (pluginBadge, cardDetail) ->
  # do we have enough data in this badge to render something meaningful
  if !isValidBadge(pluginBadge, cardDetail)
    return false
  if cardDetail
    # card detail badges need at least text
    # should it also require a title?
    # probably, but we haven't been enforcing that so :shrug:
    return _.isString(pluginBadge.text) || _.isFinite(pluginBadge.text)
  else
    # card front badge need at least text or an icon
    return isValidUrlForCSSImage(pluginBadge.icon) || _.isString(pluginBadge.text) || _.isFinite(pluginBadge.text)

# Expected Shape of pluginCover:
#   height: Number
#   url: string
#   edgeColor?: string
#   position?: 'cover' | { padding: boolean, align: 'left'|'right'|'center'}
isValidCover = (pluginCover, cardDetail) ->
  MAX_HEIGHT = 256
  MIN_HEIGHT = if cardDetail then 64 else 8
  if !pluginCover? || !_.isObject(pluginCover)
    return false
  if !isValidUrlForCSSImage(pluginCover.url)
    console?.warn('Invalid URL supplied for card-cover', pluginCover.url)
    return false
  if !isValidHeight(pluginCover.height, MAX_HEIGHT, MIN_HEIGHT)
    console?.warn('Invalid height supplied for card-cover', pluginCover.height)
    return false

  return true

isValidAlertDisplayType = (displayType) ->
  return displayType in ['info', 'success', 'warning', 'error']

isValidAlertDuration = (duration) ->
  return _.isNumber(duration) && duration >= 5 && duration <= 30

isValidStringLength = (str, min, max) ->
  return _.isString(str) && str.length >= min && str.length <= max

isValidPopupPos = (pos) ->
  return _.isObject(pos) && _.isFinite(pos.x) && _.isFinite(pos.y)

isValidUrlUnfurl = (unfurl) ->
  if !unfurl? then return false
  if !_.isString(unfurl.text) || unfurl.text.trim().length == 0
    return false
  hasNewProperty = false
  if unfurl.icon? && !isValidUrlForCSSImage(unfurl.icon)
    return false
  if unfurl.thumbnail?
    if !isValidUrlForCSSImage(unfurl.thumbnail)
      return false
    hasNewProperty = true
  if unfurl.actions?
    if !_.isArray(unfurl.actions)
      return false
    if !unfurl.actions.every((a) -> _.isString(a.text) && _.isFunction(a.callback))
      return false
    if unfurl.actions.length > 0
      hasNewProperty = true
  if unfurl.subtext?
    if !_.isString(unfurl.subtext)
      return false
    if unfurl.subtext.trim().length > 0
      hasNewProperty = true
  return hasNewProperty

module.exports = {
  isRenderableBadge,
  isValidAlertDisplayType,
  isValidAlertDuration,
  isValidAttachmentSections,
  isValidBadge,
  isValidCardBackSection,
  isValidCover,
  isValidHeight,
  isValidHttp,
  isValidHexColor,
  isValidPopupPos,
  isValidStringLength,
  isValidUrlForCSSImage,
  isValidUrlForIframe,
  isValidUrlForImage,
  isValidUrlUnfurl,
}
